// Driver documents (wave 3, tab host as the approved boards draw it): the
// verification letter, the clearance letter, the letter records and the
// yearly tax report, as before. Same access gate as before: staff roles,
// plus fleet admins whose account source is oromiabank. Only the open tab
// is mounted (YearlyTaxReport keeps its own module cache for that reason).
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DriverLetterGenerator from './DriverLetterGenerator';
import DriverClearanceLetter from './DriverClearanceLetter';
import LetterRecords from './LetterRecords';
import YearlyTaxReport from './YearlyTaxReport';
import { tokens as c } from '../theme';
import { InlineMessage } from '../components/feedback';
import { calmCaps } from '../components/modern';

export default function DriverDocuments() {
  const { t, i18n } = useTranslation();
  const auth = useSelector((state) => state.auth);
  const [value, setValue] = React.useState(0);

  const label = (key, fallback) => t(key, { defaultValue: fallback });

  // Same gate as the verification letter: staff roles, plus fleetadmins only
  // when their account source is oromiabank.
  const userType = auth.profile?.usertype;
  const userSource = auth.profile?.source;
  const hasAccess =
    ['admin', 'finance', 'callcentersupervisor', 'callcenteragent'].includes(userType) || (userType === 'fleetadmin' && userSource === 'oromiabank');

  if (!hasAccess) {
    return (
      <InlineMessage kind="error" title={label('unauthorized_access', 'Unauthorized Access')} sx={{ my: 2.5 }}>
        {label('no_permission_page', 'You do not have permission to access this page.')}
      </InlineMessage>
    );
  }

  const tabs = [
    { key: 'verification', label: label('verification_letter', 'Verification Letter'), component: <DriverLetterGenerator /> },
    { key: 'clearance', label: label('clearance_letter', 'Clearance Letter'), component: <DriverClearanceLetter /> },
    { key: 'records', label: label('letter_records', 'Letter Records'), component: <LetterRecords /> },
    { key: 'tax', label: label('yearly_tax_title', 'Yearly Tax (Ethiopia)'), component: <YearlyTaxReport /> },
  ];

  return (
    <Box dir={i18n.dir()} sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={(e, v) => setValue(v)}
        aria-label={calmCaps(t('documents'))}
        variant="scrollable"
        allowScrollButtonsMobile
        sx={{ borderBottom: `1px solid ${c.OUTLINE}` }}
      >
        {tabs.map((tab, index) => (
          <Tab key={tab.key} label={calmCaps(tab.label)} id={`docs-tab-${index}`} aria-controls={`docs-tabpanel-${index}`} />
        ))}
      </Tabs>
      <Box role="tabpanel" id={`docs-tabpanel-${value}`} aria-labelledby={`docs-tab-${value}`} sx={{ pt: 2.5 }}>
        {tabs[value].component}
      </Box>
    </Box>
  );
}
